export enum VideoStatus {
	Loading,
	NoVideo,
	MediaStatus,
	Playing,
}
